<template>
  <div class="wsqright-wrapper">
    <div class="wsqright">
      <div class="right-title" :style="{fontSize:height>1000?'30px':'24px'}">
        事件
      </div>
      <y-scroll v-if="totalTime" :contentArr="shequActive" :height="height * 0.627" :lineNum="2" :width="width*0.19" :time="5000" :totalTime="totalTime" :totalHeight="totalHeight">
        <div style="height: 100%;padding-bottom:6.85%" slot="scroll" slot-scope="props">
          <img v-if="props.todo.pic" class="wsqright-img" :src="props.todo.pic" :style="{height: height * 0.31*0.635+'px'}">
          <div class="wsqright-word">
            {{props.todo.title}}
          </div>
          <div class="wsqright-state box" >
            <div>{{props.todo.state}}</div>
            <div>{{props.todo.time}}</div>
          </div>
        </div>
      </y-scroll>
    </div>
  </div>
</template>

<script>
  import yScroll from '../../../components/yScrollYunsu'
  export default {
    components: {
      yScroll
    },
    data () {
      return {
        totalTime: 0,
        totalHeight: 0,
      }
    },
    computed:{

    },
    watch: {
      shequActive (newValue,oldValue) {
        var time = 0
        var height = 0
        this.shequActive.forEach(item => {
          if (item.pic) {
            time=time+5
            height=height+285//自己量
          }else{
            time=time+2
            height=height+108//自己量
          }
        })
        this.totalTime = 0
        this.$nextTick(() => {
          this.totalHeight = height
          this.totalTime = time
        })
      }
    },
    props:{
      height:Number,
      width:Number,
      shequActive:{
        type:Array,
        default:[]
      }
    },
  }
</script>

<style scoped>
  .wsqright-wrapper{
    width: 23.43%;
    height: 82.75%;
    margin: 0 2.08%
  }
  .wsqright{
    background-color: rgba(255,255,255,0.5);
    height: 100%;
    position: relative;
    border: 3px solid #fff;
    padding: 8.88%
  }
  .right-title{
    color: #fff;
    height:8.33%;
    width:55.55%;
    position: absolute;
    top:-5.5%;
    left:50%;
    transform: translateX(-50%);
    background: #ff6344;
    border-radius: 25px;
    box-shadow: inset 0px 0px 10px 3px #fa513a;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wsqright-img {
    /*width: 100%;*/
    /*height:63.5%;*/
  }
  .wsqright-word{
    font-size:18px;
    height:60px;
    padding: 2.2% 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .wsqright-state{
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    color:#999;
    justify-content: space-between;

  }
</style>
